import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "flex items-center gap-4" }
const _hoisted_4 = { class: "text-sm text-gray-500" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-2"
}
const _hoisted_7 = {
  key: 1,
  class: "fas fa-plus mr-2"
}
const _hoisted_8 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" }
const _hoisted_10 = { class: "aspect-video bg-gray-200 flex items-center justify-center" }
const _hoisted_11 = {
  key: 0,
  class: "text-center text-gray-500"
}
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = {
  key: 2,
  class: "absolute top-2 right-2"
}
const _hoisted_14 = { class: "p-3 bg-gray-50" }
const _hoisted_15 = { class: "flex items-center justify-between mb-2" }
const _hoisted_16 = { class: "text-sm text-gray-600" }
const _hoisted_17 = { class: "flex items-center gap-1" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick", "title"]
const _hoisted_21 = { class: "flex items-center justify-center gap-2" }
const _hoisted_22 = ["onClick", "disabled"]
const _hoisted_23 = { class: "text-xs text-gray-500" }
const _hoisted_24 = ["onClick", "disabled"]
const _hoisted_25 = {
  key: 1,
  class: "text-center py-8 text-gray-500"
}

import { ref, watch } from 'vue'
import type { LookbookFicheDisplay } from '@/types/lookbook-fiche'

interface Props {
  fiches: LookbookFicheDisplay[]
  isUploading?: boolean
}

interface Emits {
  (e: 'add-fiche', file: File | undefined): void
  (e: 'edit-fiche', fiche: LookbookFicheDisplay): void
  (e: 'delete-fiche', fiche: LookbookFicheDisplay): void
  (e: 'set-couverture', fiche: LookbookFicheDisplay): void
  (e: 'change-ordre', fiche: LookbookFicheDisplay, direction: 'prev' | 'next'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LookbookFichesList',
  props: {
    fiches: {},
    isUploading: { type: Boolean, default: false }
  },
  emits: ["add-fiche", "edit-fiche", "delete-fiche", "set-couverture", "change-ordre"],
  setup(__props: any) {

const props = __props



const fileInput = ref<HTMLInputElement>()
const selectedFile = ref<File>()

const handleFileChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  const file = target.files?.[0]
  
  if (file) {
    // Vérifier le format JPG
    if (!file.type.includes('image/jpeg')) {
      alert('Seuls les fichiers JPG sont acceptés')
      target.value = ''
      return
    }
    
    // Vérifier la taille (2 Mo max)
    const maxSize = 2 * 1024 * 1024 // 2 Mo
    if (file.size > maxSize) {
      alert('Le fichier est trop volumineux. Taille maximale : 2 Mo')
      target.value = ''
      return
    }
    
    selectedFile.value = file
  }
}

// Réinitialiser le fichier après upload réussi
watch(() => props.isUploading, (newVal, oldVal) => {
  if (oldVal && !newVal) {
    selectedFile.value = undefined
    if (fileInput.value) {
      fileInput.value.value = ''
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 mb-4" }, "Liste de fiches du Lookbook", -1)),
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "mb-6 space-y-2 text-sm text-gray-600" }, [
      _createElementVNode("p", null, "- Pour un affichage optimal de vos lookbook, la dimension de la photo ne doit pas dépasser 1600px en hauteur et en largeur, doit être inférieur à 2Mo et au format \"JPG\""),
      _createElementVNode("p", null, "- Si la taille est inférieure à 1600px la photo se redimensionnera automatiquement"),
      _createElementVNode("p", null, [
        _createTextVNode("- L'icone "),
        _createElementVNode("i", { class: "fas fa-image" }),
        _createTextVNode(" sur chacune des photos de lookbook permet de désigner une image de couverture pour l'affichage sur le catalogue d'Efashion Paris.")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          ref_key: "fileInput",
          ref: fileInput,
          type: "file",
          accept: "image/jpeg",
          onChange: handleFileChange,
          class: "hidden"
        }, null, 544),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (fileInput.value?.click())),
          class: "inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        }, " Choisir un fichier "),
        _createElementVNode("span", _hoisted_4, _toDisplayString(selectedFile.value ? selectedFile.value.name : 'Aucun fichier choisi'), 1),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('add-fiche', selectedFile.value))),
          disabled: !selectedFile.value || _ctx.isUploading,
          class: "inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
        }, [
          (_ctx.isUploading)
            ? (_openBlock(), _createElementBlock("i", _hoisted_6))
            : (_openBlock(), _createElementBlock("i", _hoisted_7)),
          _cache[2] || (_cache[2] = _createTextVNode(" Ajouter une fiche "))
        ], 8, _hoisted_5)
      ])
    ]),
    (_ctx.fiches.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "font-medium text-gray-900" }, "Liste des fiches du lookbook :", -1)),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fiches, (fiche) => {
              return (_openBlock(), _createElementBlock("div", {
                key: fiche.id,
                class: "relative border border-gray-200 rounded-lg overflow-hidden"
              }, [
                _createElementVNode("div", _hoisted_10, [
                  (!fiche.image_url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[3] || (_cache[3] = [
                        _createElementVNode("i", { class: "fas fa-image text-2xl mb-2" }, null, -1),
                        _createElementVNode("div", { class: "text-sm" }, "Aucune image", -1)
                      ])))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: fiche.image_url,
                        alt: `Fiche ${fiche.ordre}`,
                        class: "w-full h-full object-cover"
                      }, null, 8, _hoisted_12)),
                  (fiche.couverture)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[4] || (_cache[4] = [
                        _createElementVNode("span", { class: "inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800" }, [
                          _createElementVNode("i", { class: "fas fa-image mr-1" }),
                          _createTextVNode(" Couverture ")
                        ], -1)
                      ])))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, "ID: " + _toDisplayString(fiche.id), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (_ctx.$emit('edit-fiche', fiche)),
                        class: "p-1 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded",
                        title: "Éditer"
                      }, _cache[5] || (_cache[5] = [
                        _createElementVNode("i", { class: "fas fa-edit text-sm" }, null, -1)
                      ]), 8, _hoisted_18),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (_ctx.$emit('delete-fiche', fiche)),
                        class: "p-1 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded",
                        title: "Supprimer"
                      }, _cache[6] || (_cache[6] = [
                        _createElementVNode("i", { class: "fas fa-trash text-sm" }, null, -1)
                      ]), 8, _hoisted_19),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (_ctx.$emit('set-couverture', fiche)),
                        class: _normalizeClass([
                    'p-1 rounded',
                    fiche.couverture 
                      ? 'text-green-600 bg-green-100' 
                      : 'text-gray-600 hover:text-green-600 hover:bg-green-50'
                  ]),
                        title: fiche.couverture ? 'Couverture' : 'Définir comme couverture'
                      }, _cache[7] || (_cache[7] = [
                        _createElementVNode("i", { class: "fas fa-image text-sm" }, null, -1)
                      ]), 10, _hoisted_20)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: ($event: any) => (_ctx.$emit('change-ordre', fiche, 'prev')),
                      disabled: fiche.ordre === 1,
                      class: "p-1 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded disabled:opacity-50 disabled:cursor-not-allowed",
                      title: "Déplacer vers la gauche"
                    }, _cache[8] || (_cache[8] = [
                      _createElementVNode("i", { class: "fas fa-chevron-left text-sm" }, null, -1)
                    ]), 8, _hoisted_22),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(fiche.ordre), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: ($event: any) => (_ctx.$emit('change-ordre', fiche, 'next')),
                      disabled: fiche.ordre === _ctx.fiches.length,
                      class: "p-1 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded disabled:opacity-50 disabled:cursor-not-allowed",
                      title: "Déplacer vers la droite"
                    }, _cache[9] || (_cache[9] = [
                      _createElementVNode("i", { class: "fas fa-chevron-right text-sm" }, null, -1)
                    ]), 8, _hoisted_24)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_25, _cache[11] || (_cache[11] = [
          _createElementVNode("i", { class: "fas fa-book-open text-3xl mb-2" }, null, -1),
          _createElementVNode("div", null, "Aucune fiche n'existe pour ce lookbook", -1)
        ])))
  ]))
}
}

})